import { getBroadbandBundle } from '@/graphql/queries/broadband';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = route.params.code;
  await $apolloQuery(getBroadbandBundle, { code }).then(bundle => {
    if (bundle.slug !== route.params.slug || bundle.institution.slug !== route.params.provider) {
      return redirect(301, app.localePath(`/compare-tv-broadband-phone/${bundle.institution.slug}/${bundle.code}/${bundle.slug}`));
    }
    const title = [bundle.institution.name, bundle.name].join(' ');
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/broadband', '/compare-tv-broadband-phone'],
      [bundle.institution.name, `/compare-tv-broadband-phone/${bundle.institution.slug}`], bundle.name
    ]);
    store.commit('pageContent/setHead', { title, description: bundle.description });
    store.commit('products/set', bundle);
  }).catch(_ => {
    redirect(301, app.localePath('/compare-tv-broadband-phone/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.bundleNotFound') });
  });
};
